/**
 * Register a service worker and add PWA features like installing prompts
 */

export default (() => {
  // Register service worker
  if ('serviceWorker' in navigator) {
    window.addEventListener('load', () => {
      navigator.serviceWorker.register('/service-worker.js')
    })
  }
})()
